import { render, staticRenderFns } from "./LRLayout.vue?vue&type=template&id=4b0048b7&scoped=true"
import script from "./LRLayout.vue?vue&type=script&lang=js"
export * from "./LRLayout.vue?vue&type=script&lang=js"
import style0 from "./LRLayout.vue?vue&type=style&index=0&id=4b0048b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0048b7",
  null
  
)

export default component.exports